/* @ngInject */
export function SafetyPlanDocumentDetailsController(
    $scope,
    $state,
    $stateParams,
    $ngRedux,
    $mdDialog,
    SafetyPlanService,
    $filter,
    SAFETY_PLAN_REVIEW_SETTINGS,
    Notifier
) {
    $scope.trainingName = $state.current.trainingName;
    $scope.documentId = $stateParams.documentId;
    $scope.document = null;
    var dialog = null;

    SafetyPlanService.getDocumentDetails($scope.documentId).then(function(response) {
        var data = response.data[0];

        $scope.document = {
            id: $scope.documentId,
            docDcrNo: data.doc_num,
            documentName: data.title,
            documentType: data.document_type,
            docDateEditedStr: data.date_edited
                ? $filter('date')(new Date(data.date_edited), SAFETY_PLAN_REVIEW_SETTINGS.DATE_FORMAT)
                : null,
            validUntilStr: data.valid_until
                ? $filter('date')(new Date(data.valid_until), SAFETY_PLAN_REVIEW_SETTINGS.DATE_FORMAT)
                : null,
            writtenBy: data.written_by,
            location: data.location,
            locationUuid: data.location_uuid,
            documentPath: data.doc_path,
            documentTypeCode: data.document_type_code,
            version: data.version
        };
    }, function(error) {
        Notifier.error('Error loading document details');
    });

    $scope.assignAllSiteLocations = function() {
        var confirm = $mdDialog.confirm()
            .title('Are you sure?')
            .textContent('This will assign all Site Locations in the grid to this document.')
            .ariaLabel('Assign all Site Locations')
            .ok('Yes')
            .cancel('No');

        dialog = $mdDialog.show(confirm).then(function() {
            SafetyPlanService.assignDocumentLocation('all', $scope.documentId).then(function() {
                Notifier.success('All locations are assigned');

                $ngRedux.dispatch({
                    type: 'GRID_RELOAD',
                    id: 'safetyPlanDocumentLocationsGrid'
                });
            });
        }, angular.noop);
    };

    $scope.resignAllSiteLocations = function() {
        var confirm = $mdDialog.confirm()
            .title('Are you sure?')
            .textContent('This will resign all Site Locations in the grid from this document.')
            .ariaLabel('Resign all Site Locations')
            .ok('Yes')
            .cancel('No');

        dialog = $mdDialog.show(confirm).then(function() {
            SafetyPlanService.resignDocumentLocation('all', $scope.documentId).then(function() {
                Notifier.success('All locations are resigned');

                $ngRedux.dispatch({
                    type: 'GRID_RELOAD',
                    id: 'safetyPlanDocumentLocationsGrid'
                });
            });
        }, angular.noop);
    };

    $scope.goBack = function() {
        var state = $state.current.trainingType === 'lspp'
            ? 'app.safetyPlan.laser.customize.list'
            : 'app.safetyPlan.radiation.customize.list';
        $state.go(state);
    };

    $scope.$on('$destroy', function() {
        if (dialog) {
            $mdDialog.hide(dialog);
        }
    });
}